import { ContainerModule } from 'inversify';
import ClientReqData, { IClientReqData } from '@framework/router/Next/headers/ClientReqData';

export const clientReqClientDataModule = (requestHeaders: IClientReqData = {}): ContainerModule => {
  return new ContainerModule(({ bind }) => {
    bind(ClientReqData).toConstantValue(new ClientReqData(requestHeaders));
  });
};

export const serverReqClientDataModule = new ContainerModule(({ bind }) => {
  bind(ClientReqData).toDynamicValue(async () => ClientReqData.fromNextHeader());
});
